if (!customElements.get('localization-form')) {
  customElements.define('localization-form', class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.wasExpandedOnPointerDown = false;
      this.handleTabKeyDownBound = this.handleTabKeyDown.bind(this);
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('pointerdown', this.onButtonPointerDown.bind(this));
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.addEventListener('keydown', this.handleTabKeyDownBound);

      this.querySelectorAll('a:not(.external-link)').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    disconnectedCallback() {
      this.removeEventListener('keydown', this.handleTabKeyDownBound);
    }

    updateChatVisibility(isHidden) {
      const chatContainer = document.querySelector('#chat-button');
      if (chatContainer && this.elements.button.classList.contains('footer-disclosure')) {
        chatContainer.classList.toggle('gorgias-chat-container--hidden', isHidden);
      }
    }

    onButtonPointerDown() {
      this.wasExpandedOnPointerDown = this.elements.button.getAttribute('aria-expanded') === 'true';
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
      this.updateChatVisibility(false);
    }

    showPanel() {
      this.elements.button.setAttribute('aria-expanded', 'true');
      this.elements.panel.removeAttribute('hidden');
      this.updateChatVisibility(true);
    }

    isPanelOpen() {
      return this.elements.button.getAttribute('aria-expanded') === 'true' && !this.elements.panel.hasAttribute('hidden');
    }

    getFocusableElementsWhenOpen() {
      const selector = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
      const panelFocusables = Array.from(this.elements.panel.querySelectorAll(selector)).filter((el) => el.getClientRects().length > 0);
      return [this.elements.button, ...panelFocusables];
    }

    handleTabKeyDown(event) {
      const key = event.code ? event.code.toUpperCase() : event.key;
      if (key !== 'TAB' && key !== 'Tab') return;
      if (!this.isPanelOpen()) return;

      const focusables = this.getFocusableElementsWhenOpen();
      if (focusables.length === 0) return;

      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      const activeEl = document.activeElement;

      if (event.shiftKey && activeEl === first) {
        event.preventDefault();
        last.focus();
        return;
      }

      if (!event.shiftKey && activeEl === last) {
        event.preventDefault();
        first.focus();
        return;
      }

      if (!this.contains(activeEl)) {
        event.preventDefault();
        first.focus();
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector(e) {
      e.preventDefault();
      const isExpanded = this.elements.button.getAttribute('aria-expanded') === 'true';
      const shouldClose = this.wasExpandedOnPointerDown || isExpanded;
      this.wasExpandedOnPointerDown = false;

      if (shouldClose) {
        this.hidePanel();
      } else {
        this.showPanel();
      }
    }

    closeSelector(event) {
      const isChild = this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
      if (!event.relatedTarget || !isChild) {
        this.hidePanel();
      }
    }
  });
}